import styled from 'styled-components';

export const Card = styled.div`
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
    cursor: pointer;
    position: relative;
    backdrop-filter: blur(10px);
    min-width: 200px;
    height: 140px;
    scroll-snap-align: start;
    width: 200px;
    flex: ${({ isCompactView }) => isCompactView ? '0 0 auto' : '0 1 200px'};


    &:hover {
        box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
        transform: translateY(-2px);
    }
`;

export const PreviewContainer = styled.div`
    position: relative;
    width: 100%;
    height: 80px;
    background: rgba(255, 255, 255, 0.1);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PreviewImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;

    ${Card}:hover & {
        transform: scale(1.05);
    }
`;

export const FallbackPreview = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    color: #B6C2CF;
    font-size: 1.5rem;
    backdrop-filter: blur(5px);
`;

export const Content = styled.div`
    padding: 8px;
    overflow: hidden;
`;

export const Title = styled.h3`
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: #B6C2CF;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const Url = styled.p`
    margin: 4px 0 0;
    font-size: 12px;
    color: #8C9BAB;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const DeleteButton = styled.button`
    position: absolute;
    top: 8px;
    right: 8px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s ease;

    ${Card}:hover & {
        opacity: 1;
    }

    &:hover {
        background: rgba(0, 0, 0, 0.7);
    }
`;

export const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
`;